import { handleApiError } from 'utils/api';
import { env } from '../../../../constants';
import { HEALTH_INSURANCE_API_URL } from './constants';
import { HealthInsuranceResponse } from './types';

export const fetchHealthInsurancePage = async (
  type: string | undefined,
  page: number
): Promise<HealthInsuranceResponse | undefined> => {
  if (!type) return undefined;

  const response = await fetch(
    `${env.VITE_API_BASE_URL}/${HEALTH_INSURANCE_API_URL}?type=${type}&page=${page}`,
    {
      method: 'GET'
    }
  );

  if (!response.ok) {
    await handleApiError(response);
  }

  return response.json() as Promise<HealthInsuranceResponse | undefined>;
};
